import { EvFlow, OverviewTextReplacements } from "../models/shared.model";

export class StringUtils {
  static format(str: string, substitutions: {}): string {
    let result: string = str;

    Object.keys(substitutions).forEach((k) => {
      result = result.replace(`{{${k}}}`, substitutions[k as keyof typeof substitutions]);
    });

    return result;
  }

  static formatOfficeError(error: Office.Error): string {
    return error ? `${error.code}: ${error.name} - ${error.message}` : "N/A";
  }

  static parseFromAuthEmailHeader(header: string, findKey: String) {
    let res: string = null as any;
    if (header) {
      const parts: string[] = header.split(";");

      parts.forEach(part => {
        const values: string[] = part.split(" ");

        values.forEach(value => {
          const pairs: string[] = value.split("=");
          if (pairs && pairs.length > 1) {
            if (pairs[0].trim() === findKey) {
              res = pairs[1].trim();
            }
          }
        });
      });
    }

    return res;
  }

  static replacePlaceholdersOverviewText(text: string, info: OverviewTextReplacements){
    text = text.replace("%TLD%", info.tld);

    return text;
  }

  static compareCaseInsensitive(str1: string, str2: string): boolean {
    return str1?.localeCompare(str2, undefined, { sensitivity: 'base' }) === 0
  }

  static normalizeMessageHeaders(headers: string){
    return headers.replace(/\r?\n\s+/g, " ");
  }

  static extractHeader(headers: string, headerName: string) {
    const regex = new RegExp(`^${headerName}: (.+)$`, "im"); // Case-insensitive, multiline match
    const match = headers.match(regex);
    return match ? match[1].trim() : null;
  }

  static extractAllHeaderOccurrences(headers: string, headerName: string) {
    const regex = new RegExp(`^${headerName}: (.+)$`, "gim"); // Case-insensitive, multiline match
    return [...headers.matchAll(regex)];
  }

  static extractKeyValue(header: string, key: string) {
    const regex = new RegExp(`${key}=([\\w.-]+)`, "i"); // Case-insensitive match for 'key=value'
    const match = header.match(regex);
    return match ? match[1] : null;
  }

  static async sha256(input: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  }

  static async calculateChecksumPointsObj(data: EvFlow) {
    data.EvaluationFlows.forEach((flow) => {
      flow.steps.forEach((step) => {
        Object.values(step.nodePaths).forEach((nodePath) => {
          nodePath.points = null;
          nodePath.overviewText = null;
        })
      })
    })

    data.multipleConditions = null;

    const hash = await StringUtils.sha256(JSON.stringify(data));
    console.log('SHA-256 Hash:', hash);

    return hash;
  }

}
